module.exports = __webpack_public_path__ + "static/assets/86c1e3c64f35c3bef0d88ff949b23a15.svg";